import { useContext, useState, useEffect } from "react";
import CButton from "../../../../components/buttons/Button";
import CDataTable from "../../../../components/datatable/datatable";
import { LoadingContext } from "../../../../context/loadingContext";
import { downloadFileHooks } from "../../newOrders/hooks/newOrderHooks";
import { getAllOrdersList } from "../hooks/previousOrderHooks";
import PreviousOrderMobile from "./previousOrderMobile";

const PreviousOrders = () => {
  const [orderList, setOrderList] = useState([]);
  const { setLoading } = useContext(LoadingContext);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    setLoading(true);
    (async () => {
      window.addEventListener("resize", () => {
        setWindowWidth(window.innerWidth);
      });

      // Get all orders using getAllOrdersList

      const result = await getAllOrdersList();
      setOrderList(result.data);
      setLoading(false);
      if (window.innerWidth <= 992)
        document.getElementById("sidebarToggle").click();
    })();
  }, []);

  // Download file by S3bucket using downloadFileHooks

  const downloadFile = async (order_id) => {
    setLoading(true);
    const result = await downloadFileHooks(order_id);
    setLoading(false);
    const downloadBtn = document.getElementById("download-btn");
    downloadBtn.href = result;
    downloadBtn.click();
  };

  return (
    <>
      {windowWidth >= 922 ? (
        <>
          <h4 className="text-dark text-center fw-bold mt-4">All Orders</h4>
          <CDataTable
            column={[
              {
                name: "S.No",
                selector: (row, index) => index + 1,
                center: true,
              },
              {
                name: "Date",
                selector: (row) => row.order_date.split("T")[0],
                sortable: true,
                center: true,
              },
              {
                name: "Order#",
                selector: (row) => row.doi_id,
                center: true,
              },
              {
                name: "Article",
                selector: (row) => (
                  <CButton
                    btnClasses={"btn btn-sm text-decoration-none text-light"}
                    btnCustomStyle={{
                      backgroundColor: "#044389",
                    }}
                    innertext={"View File"}
                    functionName={() => downloadFile(row.doi_id)}
                  />
                ),
                center: true,
                width: "180px",
              },
              {
                name: "Advertiser",
                selector: (row) =>
                  row.data_mkt_reg.firstname + " " + row.data_mkt_reg.lastname,
                center: true,
              },
              {
                name: "Status",
                selector: (row) => row.master_order_status.name,
                sortable: true,
                center: true,
              },
              // {
              //   name: "Payment",
              //   selector: (row) =>
              //     {var res = row.trxn_order_payment_statuses.length!==0?row.trxn_order_payment_statuses[0].master_payment_status.name:""},
              //   center: true,
              // },
            ]}
            data={orderList}
            isHover={true}
            isPagination={true}
            isResponsive={true}
            customClassLabel={"fw-bold text-dark mb-3"}
            customClassDiv={"mb-4 mt-5 text-center"}
            persistTableHead={true}
            fixedHeader={true}
          />
          <a href="" className="d-none" id="download-btn"></a>
        </>
      ) : (
        <>
          <PreviousOrderMobile
            orderList={orderList}
            downloadFile={(id) => downloadFile(id)}
          />
        </>
      )}
    </>
  );
};

export default PreviousOrders;
